import React, { JSX, ReactElement } from 'react';
import {
    Edit,
    SimpleForm,
    required,
    SelectInput,
    ReferenceInput,
    TextInput,
    DateInput,
    ReferenceManyField,
    Datagrid,
    SimpleFormIterator,
    DateField, TextField, FormDataConsumerRenderParams, FormDataConsumer,
    ReferenceArrayInput,
    AutocompleteArrayInput,
    BooleanField,
    EditButton,
    Pagination
} from 'react-admin';
import {
    Grid,
    Box,
    Button
} from '@mui/material';
// This screen was a copy of `MysteryShopperEdit` and still fed itself Mystery Shopper's three
// choice lists, so a sniff's Status offered 'pending', its Channel offered 'form' - which a sniff
// has never had - and neither offered 'archive' or 'scoring', both of which the backend writes.
// A status the list does not hold renders as an empty dropdown on a record that has one.
import { complianceSnifferStatus, complianceSnifferTypes, complianceSnifferChannels } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

const MysteryShopperEditResultsEmpty: () => JSX.Element = (): JSX.Element => {
    return (
        <Box sx={ {
            width: '100%',
            height: '300px',
            border: '1px solid', borderColor: 'divider',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } }>
            <span>{ "No Results Found..." }</span>
        </Box>
    );
}

export const ComplianceSnifferEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit >
            <SimpleForm>
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <TextInput name="name" source="name" validate={[required()]} fullWidth />
                        <SelectInput
                            source="status"
                            choices={ complianceSnifferStatus }
                        />
                        <SelectInput
                            source="channel"
                            choices={ complianceSnifferChannels }
                        />
                        <ReferenceInput
                            label="company"
                            source="company"
                            reference="companies"
                        >
                            <SelectInput optionText="name"/>
                        </ReferenceInput>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "Created" }</span>
                            <DateField showTime source="createdAt"  />
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "Updated" }</span>
                            <DateField showTime source="updatedAt"   />
                        </Box>
                    </Grid>
                    <Grid size={ 6 }>
                        <SelectInput name="type" source="type" validate={[required()]} fullWidth choices={ complianceSnifferTypes } />
                        <DateInput source="startDate"  />
                        <DateInput source="endDate"  />
                        <FormDataConsumer<{ type: string }>>
                            {({
                                  formData,
                                  scopedFormData,
                                  ...rest
                              }: FormDataConsumerRenderParams<{ type: string }>): ReactElement|null => {
                                if (formData?.type?.toLowerCase() === 'customer') {
                                    return (
                                        <Box sx={ {
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        } } >
                                            <h3>{ "Compliance Sniffer Targets" }</h3>
                                            <ReferenceArrayInput source="customerTargets" reference="employees">
                                                <AutocompleteArrayInput />
                                            </ReferenceArrayInput>
                                        </Box>
                                    );
                                }
                                return null;
                            } }
                        </FormDataConsumer>
                        {/*<ReferenceManyField source="mysteryShopperResults"*/}
                        {/*                    pagination={ <Pagination /> }*/}
                        {/*                    perPage={ 10 }*/}
                        {/*                    empty={ <MysteryShopperEditResultsEmpty /> }*/}
                        {/*                    emptyText={"No Results Found."}*/}
                        {/*                    reference="mystery_shopper_results" target="id" >*/}
                        {/*    <Datagrid bulkActionButtons={ false }>*/}
                        {/*        <TextField source="id" />*/}
                        {/*        <EditButton />*/}
                        {/*    </Datagrid>*/}
                        {/*</ReferenceManyField>*/}
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}